export interface PricingPlan {
	name: string;
	description: string;
	price: { monthly: string; annual: string };
	features: string[];
	popular: boolean;
}

/** Single source of truth for the pricing page, /pricing.md, and /llms.txt. */
export const PRICING_PLANS: PricingPlan[] = [
	{
		name: "Self-Host",
		description: "Run the whole platform on your own infrastructure",
		price: { monthly: "Free", annual: "Free" },
		features: [
			"100% free forever",
			"Full control over your data",
			"Host on your infrastructure",
			"No usage limits",
			"Community support",
			"Regular updates",
		],
		popular: false,
	},
	{
		name: "Free",
		description: "Ship your first agent and see how it behaves",
		price: { monthly: "$0", annual: "$0" },
		features: [
			"Up to 3 repositories",
			"1 concurrent deployment",
			"Basic usage limits",
			"Standard bandwidth",
			"3-day data retention",
			"Community support",
		],
		popular: false,
	},
	{
		name: "Pro",
		description: "Agents running in production for real users",
		price: { monthly: "$10", annual: "$100" },
		features: [
			"Unlimited repositories",
			"Higher concurrency limits",
			"Custom domains",
			"Advanced analytics",
			"90-day data retention",
			"Priority support",
		],
		popular: true,
	},
	{
		name: "Enterprise",
		description: "Dedicated infrastructure, security review, and SLAs",
		price: { monthly: "Custom", annual: "Custom" },
		features: [
			"Everything in Pro",
			"Advanced security features",
			"Custom integrations",
			"On-boarding assistance",
			"1-year data retention (configurable)",
			"24/7 premium support",
		],
		popular: false,
	},
];

export const ANNUAL_DISCOUNT_PERCENT = 20;
